module.exports = __webpack_public_path__ + "img/logo.d1e0b4a8.png";